
import { Stack, Typography } from '@mui/material';

import RouteConstant from "@/constant/RouteConstant";
import VarietySelect from "@/pages/components/VarietySelect";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import mobileClasses from "./mobile.module.css";

const VarietyPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [selected, setSelected] = useState(null);

  return (<>
    <Stack className={mobileClasses.root}>
      <Typography sx={(theme) => ({ fontSize: theme.typography.pxToRem(28) })} className={mobileClasses.title}>{t('select_a_assets')}</Typography>
      <VarietySelect onSelect={(variety) => {
        setSelected(variety)
        navigate(`${RouteConstant.USER_WITHDRAW}?variety_code=${variety.varietyCode}`)
      }} />
    </Stack>
  </>)
}

export default VarietyPage;